import React from 'react'
import { statusColor } from '../../../../../app/javascript/packs/cities/status_color';
import { formatUnderScoreText } from '../../../../../app/javascript/packs/helpers/formatUnderscoreText';

const incident_chart = ({incidents}) => {
  return (
    <div className="card mt-4">
      <div className=" container-fluid">
        <div className="row">
          <div className="col-3 border p-3 font-weight-bold">
            Incident ID #
          </div>
          <div className="col-3 border p-3 font-weight-bold">
            Location
          </div >
          <div className="col-3 border p-3 font-weight-bold">
            Assigned Team
          </div>
          <div className="col-3 border p-3 font-weight-bold">
            Incident Status
          </div>
        </div>
      </div>
      {
        incidents && incidents.map(incident => (
          <div key={incident?.id} class="container-fluid">
            <div class="row " style={{backgroundColor:statusColor(incident.is_hotspot ? null : incident.incident_status)}} id={`incident/${incident.id}`}>
              <div class="col-3 border p-3">
                {incident?.id || "-"}
              </div>
              <div className="col-3 border p-3">
                {incident?.location?.city || incident?.location?.town || "-"}
              </div >
              <div className="col-3 border p-3">
                {incident?.assigned_team || "-"}
              </div>
              <div class="col-3 border p-3">
                {incident.is_hotspot ? "Proactive Outreach" : formatUnderScoreText(incident.incident_status)}
              </div>
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default incident_chart